import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Box, Toolbar, Typography } from '@mui/material';
import about1 from '../Image/about-img.jpg';

const About = () => {
    const { t } = useLanguage();
    return (
        <>
            <Box>
                <Toolbar>
                    <div className='about-Screen'>
                        <div className='aboutWrapper'>
                            <Typography variant='h2'>{t('about_title')}</Typography>
                            <div className='about-content'>
                                <div className='about-block'>
                                    <div className='about-img-block'>
                                        <div className='content'>
                                            <Typography variant='h4'>{t('a_title1')}</Typography>
                                            <Typography variant='body1'>{t('a_para1')}</Typography>
                                           <Typography variant='body1'>{t('list1')}</Typography>
                                           <Typography variant="body1">{t('list2')}</Typography>
                                        </div>
                                        <div className='about-image'>
                                            <img src={about1} alt="" />
                                        </div>
                                    </div>
                                </div>
                                <div className='about-block'>
                                    <Typography variant='h4'>{t('a_title2')}</Typography>
                                    <Typography variant='body1'>{t('a_para3')}</Typography>
                                    <Typography variant='h6'>{t('a_subtitle2')}</Typography>
                                    <ul>
                                        <li>{t('list3')}</li>
                                        <li>{t('list4')}</li>
                                        <li>{t('list5')}</li>
                                        <li>{t('list6')}</li>
                                         <li>{t('list7')}</li>
                                    </ul>
                                    <Typography variant='body1'>{t('listp8')}</Typography>
                                </div>
                                <div className='about-block'>
                                    <Typography variant='h4'>{t('a_title3')}</Typography>
                                    <Typography variant='body1'>{t('a_para4')}</Typography>
                                    <Typography variant='h6'>{t('a_subtitle3')}</Typography>
                                    <ul>
                                        <li><b>{t('para4_list1')}</b></li>
                                        <Typography variant='body1'>{t('para4_listp1')}</Typography>
                                        <li><b>{t('para4_list2')}</b></li>
                                        <Typography variant='body1'>{t('para4_listp2')}</Typography>
                                        <li><b>{t('para4_list3')}</b></li>
                                        <Typography variant='body1'>{t('para4_listp3')}</Typography>
                                        <ul>
                                            <li>{t('para4_sublist3')}</li>
                                            <li>{t('para4_sublist31')}</li>
                                            <li>{t('para4_sublist32')}</li>
                                        </ul>
                                        <li><b>{t('para4_list4')}</b></li>
                                        <Typography variant='body1'>{t('para4_listp4')}</Typography>
                                    </ul>
                                </div>
                                <div className='about-block'>
                                    <Typography variant='h4'>{t('a_title4')}</Typography>
                                    <Typography variant='body1'>{t('a_para5')}</Typography>
                                      <ul>
                                        <li><b>{t('para5_list1')}</b></li>
                                        <Typography variant='body1'>{t('para5_listp1')}</Typography>
                                        <li><b>{t('para5_list2')}</b></li>
                                        <Typography variant='body1'>{t('para5_listp2')}</Typography>
                                        <li><b>{t('para4_list3')}</b></li>
                                        <Typography variant='body1'>{t('para5_list3')}</Typography>
                                        <ul>
                                            <li>{t('para5_listp3')}</li>
                                            <li>{t('para5_listp31')}</li>
                                            <li>{t('para5_listp32')}</li>
                                        </ul>
                                        <li><b>{t('para5_list4')}</b></li>
                                        <Typography variant='body1'>{t('para5_listp4')}</Typography>
                                        <li><b>{t('para5_list5')}</b></li>
                                        <Typography variant='body1'>{t('para5_listp5')}</Typography>
                                    </ul>
                                </div>
                                <div className='about-block'>
                                    <Typography variant='h4'>{t('a_title6')}</Typography>
                                    <Typography variant='body1'>{t('a_para6')}</Typography>
                                    <Typography variant='body1'>{t('a_para61')}</Typography>
                                </div>
                                     <div className='about-block'>
                                    <Typography variant='h4'>{t('a_title7')}</Typography>
                                    <Typography variant='body1'>{t('a_para7')}</Typography>
                                </div>
                                     <div className='about-block'>
                                    <Typography variant='h4'>{t('a_title8')}</Typography>
                                   <ul className='title8list'>
                                    <li><Typography variant='body'>{t('para_8_list1')}</Typography></li>
                                    <li><Typography variant='body'>{t('para_8_list2')}</Typography></li>
                                    <li><Typography variant='body'>{t('para_8_list3')}</Typography></li>
                                    <li><Typography variant='body'>{t('para_8_list4')}</Typography></li>
                                   </ul>
                                </div>
                                     <div className='about-block'>
                                    <Typography variant='h4'>{t('para_9')}</Typography>
                                    <ul>
                                        <li><b>{t('para_list91')}</b></li>
                                        <Typography variant='body1'>{t('para_list911')}</Typography>
                                        <li><b>{t('para_list92')}</b></li>
                                        <Typography variant='body1'>{t('para_list922')}</Typography>
                                        <li><b>{t('para_list93')}</b></li>
                                        <Typography variant='body1'>{t('para_list933')}</Typography>
                                        <li><b>{t('para_list94')}</b></li>
                                        <Typography variant='body1'>{t('para_list944')}</Typography>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </Toolbar>
            </Box>
        </>
    );
};

export default About;